var React = require('react');

function Times (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 25.0001L25 1.00012","stroke":"#686886","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1 1.00024L25 25.0002","stroke":"#686886","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Times.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = Times;

Times.default = Times;
